import type { ContractAnswers, ContractSectionDef, VorvertragInfo } from "./types";

/**
 * Section + step layout for the Immobilie contract form, aligned with the
 * master five-section structure and the KFZ contract flow.
 *
 *  1. Allgemeine Informationen
 *     1.1 Kontakt / Versicherungsnehmer
 *     1.2 Allgemeine Informationen (Vorvertrag + Vertragsart inkl. Tarif)
 *  2. Risikoinformationen
 *     2.1 Risikoauswahl (Hauptrisiko + temporäre)
 *     2.2 Erfasste Risikoinformationen
 *  3. Vereinbarung mit dem Versicherer
 *  4. Versicherungsumfang (Summenberechnung + Umfang zusammengefasst)
 *     4.1 Versicherungssumme
 *     4.2 UVV
 *     4.3 Versicherte Gefahren (Tabelle inkl. HE/JHE/SB, Mietverlust je Gefahr)
 *     4.4 Vergleich Vorvertrag ↔ neuer Vertrag (nur Fremdvertrag)
 *     4.5 Photovoltaik
 *  5. Vertragsdaten und Zahlung
 *     5.1 Vertragsdaten & Zahlung
 *     5.2 Bedingungen & Dokumente
 *     5.3 Bemerkungen & Hinweise
 *     5.4 Zusammenfassung
 */
export const CONTRACT_SECTIONS: ContractSectionDef[] = [
  {
    key: "allgemein",
    title: "Allgemeine Informationen",
    color: "purple",
    steps: [
      {
        kind: "kontaktRisiko",
        key: "kontaktRisiko",
        title: "Kontakt & Risikoauswahl",
      },
      {
        kind: "vertragsBasis",
        key: "vertragsBasis",
        title: "Vertragsbasis",
      },
    ],
  },
  {
    key: "risiken",
    title: "Risikoinformationen",
    color: "orange",
    steps: [
      { kind: "risikoInfo", key: "risikoInfo", title: "Erfasste Risikoinformationen" },
    ],
  },
  {
    key: "vereinbarung",
    title: "Vereinbarung mit dem Versicherer",
    color: "black",
    steps: [
      {
        kind: "vereinbarung",
        key: "vereinbarung",
        title: "Vereinbarung mit dem Versicherer",
        // Nur relevant, wenn es sich um eine Rahmenvereinbarung handelt.
        showWhen: ({ answers }) =>
          (answers as ContractAnswers).tarifierung === "rahmenvereinbarung",
      },
    ],
  },
  {
    key: "umfang",
    title: "Versicherungsumfang",
    color: "green",
    steps: [
      { kind: "versicherungssumme", key: "versicherungssumme", title: "Versicherungssumme" },
      { kind: "uvv", key: "uvv", title: "Unterversicherungsverzicht" },
      { kind: "gefahren", key: "gefahren", title: "Versicherte Gefahren" },
      {
        kind: "gefahrenVergleich",
        key: "gefahrenVergleich",
        title: "Vergleich Vorvertrag ↔ neuer Vertrag",
        showWhen: ({ answers }) =>
          ((answers as ContractAnswers).vorvertrag as VorvertragInfo | undefined)?.isFremdvertrag === "ja",
      },
      { kind: "photovoltaik", key: "photovoltaik", title: "Photovoltaikdeckung" },
    ],
  },
  {
    key: "beitraege",
    title: "Vertragsdaten und Zahlung",
    color: "pillarOrange",
    steps: [
      { kind: "vertragsdatenZahlung", key: "vertragsdatenZahlung", title: "Vertragsdaten & Zahlung" },
      { kind: "bedingungenDokumente", key: "bedingungenDokumente", title: "Bedingungen & Dokumente" },
      { kind: "bemerkungenHinweise", key: "bemerkungenHinweise", title: "Bemerkungen & Hinweise" },
      { kind: "summary", key: "summary", title: "Zusammenfassung" },
    ],
  },
];
